import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'opac-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.scss'],
})
export class DividerComponent {
  @HostBinding('attr.vertical') vertical = false;

  @Input('vertical') set isVertical(value: boolean) {
    this.vertical = value;
    this.orientation = value ? 'vertical' : 'horizontal';
  }

  orientation = 'horizontal';
}
